import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from '../../actions/index'
import { Card, CardHeader, CardBody } from '../Card'
import ToggleSwitch from '../ToggleSwitch'
import { currentUtcDateTime } from '../../utils/dateTime'
import { pushContentToMatomo } from '../../utils/matomo'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

class SavedSearchPaddleRow extends Component {
  constructor(props) {
    super(props);
  }

  setDaily = (val) => {
    let updatedSavedSearches = this.props.userSearches.savedSearches.map(element => element.id == this.props.id ? { ...element, savedSearchAlert: val, dateModified: currentUtcDateTime() } : element)
    this.props.apiCallFunc(updatedSavedSearches)
  }

  setInstantAlert = (val) => {
    let updatedSavedSearches = this.props.userSearches.savedSearches.map(element => element.id == this.props.id ? { ...element, savedSearchInstantAlert: val, dateModified: currentUtcDateTime() } : element)
    this.props.apiCallFunc(updatedSavedSearches)
  }

  deleteSavedSearch = () => {
    let updatedSavedSearches = this.props.userSearches.savedSearches.filter(x => x.id != this.props.id)
    this.props.apiCallFunc(updatedSavedSearches)
    this.pushToMatomo("savedsearch_itemdelete", "delete")
  }

  pushToMatomo = (uiEvent, uiValue) => {
    var contextData = {
      "savedSearchId": this.props.id,
      "savedSearchName": this.props.name
    }

    pushContentToMatomo(uiEvent, 'personalize', 'alerts', 'click', uiValue, contextData)
  }

  confirmDelete = (e) => {
    e.preventDefault()
    confirmAlert({
      title: 'Confirm deletion',
      message: 'Are you sure you want to delete this saved search?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.deleteSavedSearch()
          }
        },
        {
          label: 'Cancel',
          onClick: () => { }
        }
      ]
    });
  };

  render() {
    return (
      <div className='card_body_row' id={`savedSearchId${this.props.id}`}>
        <span className='saved_search_name'>
          <a className='hyperLink' rel='noopener noreferrer' href={this.props.url} onClick={() => this.pushToMatomo("savedsearch_linkclick", this.props.name)}>
            {this.props.name}
          </a>
        </span>
        <span className='save-search-toggle'>
          <span className='right-align-button-spacer'>
            <ToggleSwitch
              id={`tsSavedSearchIa${this.props.id}`}
              Name={`tsSavedSearchIa${this.props.id}`}
              datagmupn='personalize'
              datagmuc='alerts'
              datagmue='savedsearch_instanttoggle'
              datagmua='click'
              savedSearchId={this.props.id}
              savedSearchName={this.props.name}
              defaultChecked={this.props.savedSearchInstantAlert}
              apiCallFunc={this.setInstantAlert}
              text='Instant Alert'>
            </ToggleSwitch>
          </span>
          <span>
            <ToggleSwitch
              id={`tsSavedSearch${this.props.id}`}
              Name={`tsSavedSearch${this.props.id}`}
              datagmupn='personalize'
              datagmuc='alerts'
              datagmue='savedsearch_dailytoggle'
              datagmua='click'
              savedSearchId={this.props.id}
              savedSearchName={this.props.name}
              defaultChecked={this.props.savedSearchAlert}
              apiCallFunc={this.setDaily}
              text={`Daily Wrap-up | ${this.props.savedSearchAlertTime} (GMT)`}>
            </ToggleSwitch>
          </span>
        </span>
        <span className='save-search-buttons'>
          <span className='right-align-button-spacer'>
            <a className='footer_button' id={`delSavedSearch${this.props.id}`} onClick={this.confirmDelete} href='#'>
              <span className='footer_button_icon'></span>
              <span className='button_icon_text font-14'>Delete</span>
            </a>
          </span>
          <span>
            <a className='footer_button' id={`editSavedSearch${this.props.id}`} href={`/#/SaveSearch/${this.props.id}`} target='_self' >
              <span className='footer_button_icon'></span>
              <span className='button_icon_text font-14'>Edit</span>
            </a>
          </span>
        </span>
      </div>
    )
  }
}

export default SavedSearchPaddleRow
